import { Type, Transform } from 'class-transformer'
import { DateTime, Duration } from 'luxon'
import { AvailabilityCheckStatus, NurseTier, PaymentOption, Role } from 'types/types'

export default class AvailabilityCheckResult {
    id!: number
    availability_check_id!: number
    nurse_id!: number
    status!: AvailabilityCheckStatus
    note!: string
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    created_at!: DateTime

    @Type(() => DateTime)
    @Transform(({ value }) => value ? DateTime.fromISO(value) : null)
    updated_at!: DateTime | null

    @Type(() => DateTime)
    @Transform(({ value }) => value ? DateTime.fromISO(value) : null)
    first_updated_at!: DateTime | null

    @Type(() => DateTime)
    @Transform(({ value }) => value ? DateTime.fromISO(value) : null)
    sms_sent_at!: DateTime | null

    sms_id!: string

    // annotate availability check
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    availability_check_start_at!: DateTime

    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    availability_check_end_at!: DateTime

    @Type(() => Duration)
    @Transform(({ value }) => Duration.fromMillis(1000 * Number(value)))
    availability_check_lunch_break!: Duration

    availability_check_postcode!: string
    availability_check_practice_name!: string
    availability_check_payment_option!: PaymentOption
    availability_check_settlement_days!: number
    availability_check_role!: Role
    availability_check_sedation_required!: boolean
    availability_check_radiography_required!: boolean
    availability_check_implant_required!: boolean
    availability_check_orthodontics_required!: boolean
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    availability_check_created_at!: DateTime

    // annotate nurse
    nurse_first_name!: string
    nurse_last_name!: string
    nurse_email!: string
    nurse_phone!: string
    nurse_approved!: boolean
    nurse_extended_compliance_approved!: boolean
    nurse_hygienist_approved!: boolean
    nurse_sedation_approved!: boolean
    nurse_radiography_approved!: boolean
    nurse_implant_experience!: string
    nurse_orthodontics_experience!: string
    nurse_tier!: NurseTier
    nurse_tz!: string

    // annotate is_expired
    is_expired!: boolean

    // computed distance between check's postcode and nurse
    distance_km!: number | null
}